import { createPortal } from 'react-dom';

import { Icons } from '@/assets/icons/icons';
import { IconButton } from '@/components/ui/IconButton';
import { trackEvent } from '@/utils/analytics';

import { MessageImageCard } from './MessageImageCard';
import { useCopyAsImage } from './useCopyAsImage';

type CopyAsImageButtonProps = {
  text: string;
  threadId: string;
  messageId: string;
  messageIndex: number;
};

export const CopyAsImageButton = ({
  text,
  threadId,
  messageId,
  messageIndex,
}: CopyAsImageButtonProps) => {
  const { imageRef, isRendering, isCopied, copyAsImage } = useCopyAsImage(() =>
    trackEvent('MESSAGE_LB_COPY_IMAGE_CLICKED', {
      chatId: threadId,
      messageIndex,
    })
  );

  return (
    <>
      <IconButton
        size="xs"
        icon={Icons.copyImage}
        isLoading={isRendering}
        onClick={copyAsImage}
        aria-label="Copy response as image"
        tooltip={isCopied ? 'Copied to clipboard' : 'Copy as image'}
        tooltipOptions={{ showOnUpdate: true }}
      />
      {isRendering &&
        createPortal(
          <div
            aria-hidden
            className="pointer-events-none fixed top-0 -left-[999rem]"
          >
            <MessageImageCard
              ref={imageRef}
              messageId={messageId}
              text={text}
            />
          </div>,
          document.body
        )}
    </>
  );
};
